const Recommendations = [
  {
    path: '/recommendation',
    name: 'recommendations',
    component: () => import(/* webpackChunkName: "recommend" */'./views/Recommendations.vue'),
    meta: {
      requiresAuth: true,
      title: 'AlgoStack Analytics Recommendations',
    },
    children: [
      {
        path: 'kpi',
        name: 'recommendations-kpi',
        component: () => import(/* webpackChunkName: "recommend" */'./components/Kpi.vue'),
        meta: {
          requiresAuth: true,
          title: 'AlgoStack Analytics Recommendations',
        },
      },
      {
        path: 'triggers',
        name: 'recommendations-triggers',
        component: () => import(/* webpackChunkName: "recommend" */'./components/Triggers.vue'),
        meta: {
          requiresAuth: true,
          title: 'AlgoStack Analytics Recommendations',
        },
      },
    ],
  },
];

export default Recommendations;
